
import Autocomplete from '@mui/material/Autocomplete';
import  { ReactElement,  useState, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import DeleteIcon from '@mui/icons-material/HighlightOff';
import IconButton from '@mui/material/IconButton';

export interface Condition {
    key: string;
    comparator: string;
    value: string;
}


export default function ConditionBuilderComponent(props: { keys: string[], initialCondition: Condition | null, onChangeCondition: (condition: Condition | null) => void }): ReactElement {
    const { keys, initialCondition, onChangeCondition } = props;
    const [comparator, setComparator] = useState<string>(initialCondition ? initialCondition.comparator : 'IS');
    const [value, setValue] = useState<string>(initialCondition ? initialCondition.value : '');
    const [keySelected, setKeySelected] = useState<string | null>(initialCondition ? initialCondition.key : null);
    const DEFAULT_COMPARATOR_LIST = ['IS', 'IS NOT', 'LIKE', '<=', '>='];

    useEffect(() => {
        if (initialCondition) {
            setKeySelected(initialCondition.key);
            setComparator(initialCondition.comparator);
            setValue(initialCondition.value);
        }
    }, [initialCondition]);
    return (           
        keySelected? 
            <Stack direction='row' spacing={2} justifyContent='start' sx={{border: '2px', width:'100%'}}>
                <TextField
                    label='Key'
                    defaultValue={keySelected}
                    variant='filled'
                    inputProps={{
                        input: { readOnly: true },
                    }}
                />
                <Autocomplete
                    options={DEFAULT_COMPARATOR_LIST}
                    getOptionLabel={(option: string): string => option}
                    renderInput={(params): any => <TextField {...params} label="Comparator" variant='filled' />}
                    value={comparator}
                    onChange={(_event: any, newValue: string | null): void => {
                        setComparator(newValue ?? 'IS');
                        onChangeCondition({ key: keySelected!, comparator: newValue ?? 'IS', value: value });
                    }}
                    sx={{width: '250px'}}
                />
                <TextField
                    label='Value'
                    variant='filled'
                    value={value}
                    onChange={(event: any): void => {
                        setValue(event.target.value);
                        onChangeCondition({ key: keySelected!, comparator: comparator, value: event.target.value });
                    }}
                />
                <IconButton
                    size='small'
                    component='button'
                    edge='end'
                    onClick={(): void => { setKeySelected(null); onChangeCondition(null); }}>
                    <DeleteIcon sx={{width: 25, height: 25}}/>
                </IconButton>
                
            </Stack> : 
            <Autocomplete
                options={keys}
                getOptionLabel={(option: string): string => option}
                renderInput={(params): any => <TextField {...params} label="Key-value pair" />}
                onChange={(_event: any, newValue: string | null): void => {
                    setKeySelected(newValue);
                    onChangeCondition({ key: newValue!, comparator: comparator, value: value });
                }}
                fullWidth
            />
    )
}
